import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {fromJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';
import {DriverPerformanceReportRecord} from './driver-performance-report.record';

export class DriverPerformanceReportCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/reports/performerPerformanceReport';

    async load(): Promise<DriverPerformanceReportRecord[]> {
        return httpService
            .get(this.apiPath, {transformResponse: (data: any) => new Function(' return ' + data)()})
            .then((response: any) =>
                response.data.reportRecords.map((val: DriverPerformanceReportRecord, n: number) =>
                    fromJson(DriverPerformanceReportRecord, Object.assign(val, {id: n}))
                )
            );
    }

    exportReport(fileName: string): Window {
        const url: string =
            httpService.getBaseUrl() + this.apiPath + '/' + Date.now() + '/?type=Excel&fileName=' + fileName;
        const result: Window = window.open(url, '_blank');
        return result;
    }
}
